import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface SetFlowDraftNameParams {
 readonly id: string;
 readonly name: string;
}

export interface SetFlowNameDraftResult extends IResult {
}

export class SetFlowDraftNameRequest extends Request<SetFlowDraftNameParams, SetFlowNameDraftResult> {
 constructor(params: SetFlowDraftNameParams) {
   super('setFlowDraftName', params);
 }
}